import Vue from 'vue';
import Vuex from 'vuex';
import { callRequestState, callRequestActions, callRequestMutations } from './call-request-vuex';
Vue.use(Vuex);

export default new Vuex.Store({
	strict: process.env.NODE_ENV !== 'production',
	state: callRequestState,
	mutations: callRequestMutations,
	actions: callRequestActions
});
